import * as React from 'react';
import { NavLink } from 'react-router-dom';
import Routes from '../../constants/Routes';
import { withUser } from '../../helpers/withUser';
import { compose } from 'recompose';
import styled from 'styled-components';

const StyledNavBar = styled.div`
  padding: 0 20px;
`;

const StyledNavLink = styled(NavLink)`
  color: #fff;
  padding: 0 10px;
  text-decoration: none;
`;

interface Props {
  user: {
    loggedIn: boolean;
  };
  logout: () => void;
}

const NavBar: React.SFC<Props> = ({ user: { loggedIn } }) => (
  <StyledNavBar>
    Dev Bar:
    <StyledNavLink to={Routes.authLogin}>Login</StyledNavLink>
    <StyledNavLink to={Routes.props}>Props</StyledNavLink>
    <StyledNavLink to={Routes.privTest}>Private</StyledNavLink>
  </StyledNavBar>
);

export default compose(withUser)(NavBar);



// WEBPACK FOOTER //
// ./src/containers/Site/NavBar.tsx